import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, skip, switchMap } from 'rxjs';
import { DataSource } from 'src/app/models/DataSource';
import { Ope } from 'src/app/models/Ope';
import { OpeDetail } from 'src/app/models/OpeDetail';
import { OpeExt } from 'src/app/models/OpeExt';
import { SearchOpeBiCriteria } from 'src/app/models/SearchOpeBiCriteria';
import { SearchOpeCriteria } from 'src/app/models/SearchOpeCriteria';
import { environment } from 'src/environments/environment';
import { shareOpeSevices } from '../sharedservices/shareOpe.services';
import { collabService } from '../collab/collabService.service';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class OpeService implements OnInit{
 
  BASE_PATH_OPEBYCRITERIA = "/programmes-lots/ope_v/ope-criteria";
  BASE_PATH_OPEBYCRITERIA_VND = "/programmes-lots/ope_v/ope-criteria-vnd";
  BASE_PATH_OPE_DETAIL = "/programmes-lots/ope/ope/num_ope/ope-detail";
  BASE_PATH_OPEEXTRAV_NONAFFECT= "/vendeurs/entite/getOpesNonAffecteBynumEntite/";
  BASE_PATH_ADD_OPEEXTRAV= "/vendeurs/entite/addAffectation/";


  
  criteriaSearch!: SearchOpeBiCriteria;
  roleCollab!: string;
  public evenetlestnet = new BehaviorSubject<any>(null!);
  //public evenetlestnet$ = this.evenetlestnet.pipe(
  //  skip(1),switchMap((criteriaSearchs: SearchOpeCriteria)=>
  //  this.getOpebyCriteria(criteriaSearchs)
  //  )
  //);

  constructor(private readonly http: HttpClient,private readonly share: shareOpeSevices, private readonly collab: collabService) {

    this.criteriaSearch = new SearchOpeBiCriteria();
    this.share.userProfilshared$.subscribe(data=>{

    
      //this.collab.getCollabByEmail(data.mail);
      if(data!=null)
        if(data.role.length>0)
          this.roleCollab=data.role[0]
      
        
    
  })
    
    

  }
  ngOnInit(): void {
    this.share.userProfilshared$.subscribe(data=>{

    
      //this.collab.getCollabByEmail(data.mail);
      if(data!=null)
        if(data.role.length>0)
          this.roleCollab=data.role[0]
      
        
    
  })

  

  }

  

  getOpebyCriteria = (filtre: SearchOpeCriteria, role: string): Observable<DataSource<Ope>> => {

    

    let urlRecherche: string;
    
    if(role==="externe"){
      
      urlRecherche = this.BASE_PATH_OPEBYCRITERIA_VND;
    }
    else{
      urlRecherche = this.BASE_PATH_OPEBYCRITERIA;
    }

      const url = `${environment.host.domaine + urlRecherche}?`;
    return this.http.get<DataSource<Ope>>(url, { params: this.ToHttpParams(filtre, 0, 250) });

    
  }

  



  public ToHttpParams(request: any | null | undefined, page: number, size: number): HttpParams {

    let httpParams = new HttpParams();
   
    if(request != null && request != undefined){
    Object.keys(request).forEach((key) => {

      if (request[key]) {

        httpParams = httpParams.append(key, request[key]);
      }
    });
  }
    httpParams = httpParams.append("page", page);
    httpParams = httpParams.append("size", size);
    
    return httpParams;

  }

 
  getOpeDetail = (numOpe: number, filtre: SearchOpeCriteria): Observable<OpeDetail> => {

    const url = `${environment.host.domaine + this.BASE_PATH_OPEBYCRITERIA.replace("num_ope", "" + numOpe)}?`;
    return this.http.get<OpeDetail>(url
      , { params: this.ToHttpParams(filtre, 0, 10) },
      );
  }

  getOpeExtravNonAffecte( numOpe: number): Observable<OpeExt[]>
  
  {
    const url = environment.host.domaine + this.BASE_PATH_OPEEXTRAV_NONAFFECT+numOpe;
    // const url = "https://cloud-ide-extrav-realestate.staging.echonet/user/e77868/http/8091/entite/getOpesNonAffecteBynumEntite/"+numOpe;
    return this.http.get<OpeExt[]>(url);
  }

  addAffectationOpeEntite(opes: OpeExt[], number: any, user: String) : Observable<OpeExt[]>{
    let body: any[];

    body  = opes.map((element) =>{
      return {
        "nom":element.nom,
        "numOpe":element.numOpe
      }
    });
    const url = environment.host.domaine + this.BASE_PATH_ADD_OPEEXTRAV+number+"?user="+user;

    // let headers = new HttpHeaders({ 'Content-Type': 'application/json','accept': 'application/json'});
    let headers = new HttpHeaders({ 'Content-Type': 'application/json','accept': 'application/json' });
    return this.http.post<OpeExt[]>(url,body,{headers: headers})


  }


}